import {
    addToChainAfter,
} from "@insite/client-framework/HandlerCreator";
import { chain,DispatchBeginPlaceOrder,SetECheck } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";

type XcPlaceOrderProps = Parameters<typeof DispatchBeginPlaceOrder>[0];

function SetCartNotes(props: XcPlaceOrderProps) {
    const state = props.getState();
    const editedCartNotes = state.pages.checkoutShipping.editedCartNotes || "";
    const { cartToUpdate } = props;
    cartToUpdate.notes = editedCartNotes;
}

addToChainAfter(chain, SetECheck,SetCartNotes);

